import { Palette } from '@mui/material/styles';

declare module '@mui/material/styles/createPalette' {
  export interface Palette {
    accent: Palette['primary'];
    boxshadow: Palette['primary'];
    border: Palette['primary'];
    disposition: DispositionColor;
    agentState: AgentStateColor;
  }
  export interface PaletteOptions {
    accent: PaletteOptions['primary'];
    boxshadow: PaletteOptions['primary'];
    border: PaletteOptions['primary'];
    disposition: DispositionColor;
    agentState: AgentStateColor;
  }

  export interface PaletteColor {
    secondary?: string;
    hover?: string;
  }
  export interface SimplePaletteColorOptions {
    secondary?: string;
    hover?: string;
  }

  export interface TypeText {
    primary: string;
    secondary: string;
    main: string;
    contrastText: string;
    light?: string;
    dark?: string;
    content?: string;
    active?: string;
    information: string;
    header: string;
    highlight?: string;
    noteLabel: string;
    messageText: string;
    black: string;
    grey: string;
    white: string;
    searchTitle: string;
    filter: string;
    yellowWarning: string;
    clearText: string;
    noResult: string;
    red: string;
    green: string;
    lightGrey: string;
    charcolGrey: string;
  }
  export interface TypeBackground {
    level1: string;
    LogoColor: string;
    main?: string;
    hover?: string;
    hoverDark?: string;
    light?: string;
    dark?: string;
    lightCoolGray: string;
    toolTipBg: string;
    callControlHeader?: string;
    sparkleBlue: string;
    toastBackground: string;
    outboundOptionBg: string;
    scrollTrack: string;
    scrollThumb: string;
    scrollThumbHover: string;
    likeReaction: string;
    noteInput: string;
    noteBackground: string;
    socialReaction: string;
    transparent: string;
    selectedQueue: string;
    digitalTag: string;
    header: string;
    lightBlue: string;
    darkGrey: string;
    lightYellow: string;
    darkYellow: string;
    zoomIconsBackground: string;
    copilotCardBackground: string;
    darkBlue: string;
    checkboxHover: string;
    callControls: string;
    copilotAddButton: string;
    copilotGenerateButton: string;
    audioPlayerColor:string;
    slateGrey: string;
  }

  export interface DispositionColor {
    required: string;
    optional: string;
  }
  export interface AgentStateColor {
    available: string;
    unavailable: string;
    working: string;
  }
}
